<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let land of bundeslandFilterService.getSelectedBundesLaenderNamen()" [label]="land">
    <app-radiobremen *ngIf="selectedBundesland === BREMEN"></app-radiobremen>
    <app-wdr *ngIf="selectedBundesland === NRW"></app-wdr>
    <app-br *ngIf="selectedBundesland === BAYERN"></app-br>
    <app-rbb *ngIf="selectedBundesland === BERLIN || selectedBundesland === BRANDENBURG" [selectedBundesland]="selectedBundesland"></app-rbb>
    <div class="wetter_content_container" *ngIf="![BRANDENBURG,BERLIN, BREMEN, NRW, BAYERN].includes(selectedBundesland)">
      <h2>Es liegen keine Wetterberichte für {{selectedBundesland}} vor</h2>
    </div>
  </mat-tab>
</mat-tab-group>
